export const iconClassName = margin => (margin ? `m${margin.charAt(0)}1` : '')
